import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

const SortingHead = (props: React.PropsWithChildren) => {
  return (
    <Box
      background="grey200"
      paddingX="s16"
      paddingY="s24"
      width="full"
      alignItems="center"
      justifyContent="spaceBetween"
    >
      {props.children}
    </Box>
  )
}

export default SortingHead
